import { render, staticRenderFns } from "./dspDescribe.vue?vue&type=template&id=3a04c306&scoped=true&"
import script from "./dspDescribe.vue?vue&type=script&lang=js&"
export * from "./dspDescribe.vue?vue&type=script&lang=js&"
import style0 from "./dspDescribe.vue?vue&type=style&index=0&id=3a04c306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04c306",
  null
  
)

export default component.exports